module.exports = __webpack_public_path__ + "img/pt-toggle.da7b10cf.svg";